var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 36,
    viewBox: "0 0 51 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0223 10.0647C15.3497 10.6497 15.3497 11.5947 16.0223 12.1797L22.714 17.9997L16.0223 23.8197C15.3497 24.4047 15.3497 25.3497 16.0223 25.9347C16.6949 26.5197 17.7815 26.5197 18.4541 25.9347L26.3704 19.0497C27.043 18.4647 27.043 17.5197 26.3704 16.9347L18.4541 10.0497C17.7987 9.47967 16.6949 9.47967 16.0223 10.0647Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.543 10.0647C24.8704 10.6497 24.8704 11.5947 25.543 12.1797L32.2348 17.9997L25.543 23.8197C24.8704 24.4047 24.8704 25.3497 25.543 25.9347C26.2157 26.5197 27.3022 26.5197 27.9748 25.9347L35.8911 19.0497C36.5637 18.4647 36.5637 17.5197 35.8911 16.9347L27.9748 10.0497C27.3195 9.47967 26.2157 9.47967 25.543 10.0647Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowRight);
export default __webpack_public_path__ + "static/media/DoubleArrowRight.d6d4b74d1628be532fbcc22edba6beda.svg";
export { ForwardRef as ReactComponent };